// firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getDatabase } from "firebase/database";
// (Optional) If you later want storage, auth, etc. you can also import them here

// Import your config defaults
import firebaseConfig from "/js/lib/firebase-config.js";

// Only initialize if no apps have been initialized yet
let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
  console.log("✅ Firebase initialized");
} else {
  app = getApps()[0]; // reuse the existing one
}

// If you want the raw app as well:
export { app };
